import { IComponentOptions } from "angular";
import { MachineConfigurationDetailViewComponentController } from "./controller";

export const vsComponentName = "machineConfigurationDetailView";

export const MachineConfigurationViewDetailComponentOptions: IComponentOptions =
  {
    controller: MachineConfigurationDetailViewComponentController,
    controllerAs: "machineConfigurationViewController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      machine: "<",
      machineConfiguration: "<",
    },
  };
